import { useNavigate } from "react-router-dom";

const MANAGE_PATH = "/manage";

export default function ManagePageHeader({ pageTitle }) {
  const navigate = useNavigate();
  const goBack = () => navigate(MANAGE_PATH);

  return (
    <div style={styles.wrap}>
      <div style={styles.breadcrumb}>
        <span>Administration</span> &gt;{" "}
        <span
          onClick={goBack}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              goBack();
            }
          }}
          role="link"
          tabIndex={0}
          style={styles.breadcrumbLink}
          onMouseEnter={(e) => { e.currentTarget.style.textDecoration = "underline"; }}
          onMouseLeave={(e) => { e.currentTarget.style.textDecoration = "none"; }}
          title="Click to go to Manage Menu"
        >
          Manage
        </span>
        {pageTitle ? <> &gt; <span style={styles.currentTitle}>{pageTitle}</span></> : null}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    marginBottom: "16px",
  },
  breadcrumb: {
    fontSize: "12px",
    color: "#94a3b8",
  },
  breadcrumbLink: {
    color: "#2563eb",
    fontWeight: "600",
    cursor: "pointer",
  },
  currentTitle: {
    color: "#0f172a",
    fontWeight: "600",
  },
};
